<div *ngIf="isLoading; else loaded">
  <div class="loading-section">
    <div class="margin-auto">
      <app-main-loader-lottie></app-main-loader-lottie>
    </div>
  </div>
</div>

<ng-template #loaded>
  <div class="header_checkout">
    <div class="row header_checkout-container">
      <div>
        <div class="header_checkout__title" *ngIf="editMode; else newCheckoutTitle">
          {{ editableCheckoutName }}
        </div>
        <ng-template #newCheckoutTitle>
          <div class="header_checkout__title">Add a delivery method</div>
        </ng-template>
      </div>
      <ng-template pdqHeaderContent>
        <div class="header_checkout__actions">
          <pdq-button
            label="Discard"
            [disabled]="updatesExistingMethod && !changeTracker.hasUnsavedChanges"
            (onClick)="onDiscard()"></pdq-button>

          <pdq-button
            label="Save"
            variant="primary"
            [disabled]="isSaveDisabled()"
            [loading]="isSaving"
            (onClick)="onSubmit()">
          </pdq-button></div
      ></ng-template>
    </div>
  </div>

  <div class="checkout" cdkScrollable>
    <form [formGroup]="formGroup">
      <div class="content checkoutContent">
        <div class="guide-section">
          <div class="row">
            <div class="guide-section__title">
              Test mode
              <div class="guide-section__subtext">
                Preview this checkout method on your live store (hidden from customers).
                <br />
                How to test: enter “PDQ” in Address Line 2 at checkout to see PDQ rates
              </div>
            </div>
            <div class="content__test-mode">
              <pdq-slide-toggle formControlName="isTestMode"></pdq-slide-toggle>
            </div>
          </div>
        </div>

        <div class="guide-section" *ngIf="stepOne">
          <div class="row">
            <div class="guide-section__title">
              Delivery method
              <div class="guide-section__subtext">Choose the type of delivery</div>
            </div>
            <div style="display: flex; flex-direction: column">
              <div class="content__delivery-type">
                <div class="row">
                  <mat-button-toggle-group #toggleGroup="matButtonToggleGroup" [value]="shippingMethodCategory">
                    <mat-button-toggle
                      (click)="onButtonChange({ value: type.name })"
                      [value]="type.name"
                      [ngClass]="type.display(shopSettings?.shopCountyCode, shop) ? 'type-icon' : 'display-none'"
                      *ngFor="let type of deliveryTypeBtnConfig"
                      [class.checked]="shippingMethodCategory === type.name">
                      <span
                        *ngIf="
                          type.deliveryType === 'shippings' &&
                          deliveryType === 'shippings' &&
                          type.display(shopSettings?.shopCountyCode, shop)
                        "
                        class="delivery-method-type">
                        <img [src]="type.icon" />
                        <div class="type-icon__text">{{ type.displayName }}</div>
                        <div class="sub-text">{{ type.subText }}</div>
                      </span>
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </div>
              <div
                *ngIf="isInternationalMethod() && !shop?.internationalSettings?.isActive"
                class="row international-warning">
                <div class="international-warning__banner">
                  <pdq-banner
                    [closable]="false"
                    variant="attention"
                    content="Activate international settings to enable this delivery type"
                    bannerTitle="Activate international settings first"></pdq-banner>
                </div>
              </div>
              <pdq-banner
                *ngIf="!!runningABTest"
                style="margin: 16px 0 0 0"
                [closable]="false"
                variant="attention"
                bannerTitle="Live A/B test is running">
                <div class="running-abtest-banner">
                  <div>Some options here are disabled because of a live A/B test.</div>
                  <pdq-button variant="light" label="Edit and restart test " (onClick)="onEndAndEditABTest()">
                  </pdq-button>
                </div>
              </pdq-banner>
            </div>
          </div>
        </div>
        <div #categoryForm *ngIf="!isInternationalMethod() || shop?.internationalSettings?.isActive">
          <div *ngIf="stepTwo && stepOne">
            <ng-container *ngIf="shippingMethodCategory !== ShippingMethod.STORE_PICK_UP">
              <ng-container
                *ngIf="
                  shippingMethodCategory === ShippingMethod.DOMESTIC_LIVE_RATE ||
                    shippingMethodCategory === ShippingMethod.FIXED_LIVE_RATE ||
                    shippingMethodCategory === ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE ||
                    shippingMethodCategory === ShippingMethod.INTERNATIONAL_LIVE_RATE;
                  else showDefaultRecommendedDelivery
                ">
                <app-new-recommended-delivery
                  [formGroup]="formGroup"
                  [deliveryType]="deliveryType"
                  [shipmentExtrasFormGroup]="shipmentExtrasFormGroup"
                  [shippingMethodCategory]="shippingMethodCategory"
                  [showFormErrors]="showFormErrors"
                  [shipmentExtrasValues]="shipmentExtras"
                  [loadedCarrier]="loadedCarrier"
                  [shop]="shop"
                  [shopSettings]="shopSettings"
                  (shipmentExtrasLoaded)="onShipmentExtrasLoaded()">
                </app-new-recommended-delivery>
              </ng-container>

              <ng-template #showDefaultRecommendedDelivery>
                <app-recommended-delivery
                  [formGroup]="formGroup"
                  [deliveryType]="deliveryType"
                  [shipmentExtrasFormGroup]="shipmentExtrasFormGroup"
                  [shippingMethodCategory]="shippingMethodCategory"
                  [showFormErrors]="showFormErrors"
                  [shipmentExtrasValues]="shipmentExtras"
                  [loadedCarrier]="loadedCarrier"
                  [shopSettings]="shopSettings"
                  [polygonAddress]="polygonAddress"
                  (resetShopSettings)="initShopSettings()"
                  (shipmentExtrasLoaded)="onShipmentExtrasLoaded()">
                </app-recommended-delivery>
              </ng-template>
            </ng-container>

            <div class="guide-section" id="top">
              <general-settings
                [shop]="shop"
                [formGroup]="formGroup"
                [deliveryType]="deliveryType"
                [shippingMethodCategory]="shippingMethodCategory"
                [showFormErrors]="showFormErrors"
                [loadedValues]="loadValues"
                [runningABTest]="runningABTest"
                [requiredFormControlsMap]="requiredFormControlsMap"
                [shopCurrency]="shopSettings?.shopCurrency"
                (deliveryMethodSectionsLoaded)="onDeliveryMethodSectionsLoaded($event)">
              </general-settings>
            </div>

            <!--          LOCATION SETTINGS-->
            <div class="guide-section">
              <div class="row">
                <div class="guide-section__title">
                  <div
                    class="pen_tool-tooltip"
                    [ngStyle]="{ top: tooltipPositionCalc }"
                    *ngIf="formGroup.get('geoDeliveryArea')?.value != true && showPenToolToolTip">
                    <div class="penTooltip rotating">Click here to draw area’s borders</div>
                  </div>

                  <span>Geo-settings</span>
                  <div class="guide-section__subtext">
                    Choose where orders ship from and which regions this delivery method applies to. Only orders to
                    cities within that area will see this delivery method.
                  </div>
                </div>
                <div class="content__geography-settings">
                  <ng-container *pdqHiddenInGlobaleMode>
                    <div class="flex-column">
                      <pdq-heading element="h6" style="padding: 16px 0 0 0">Ship from</pdq-heading>
                      <span class="content__general-settings__text">
                        {{
                          shippingMethodCategory === ShippingMethod.STORE_PICK_UP
                            ? 'Your fulfillment location will be used to determine which pickup location this method is related to'
                            : 'Your fulfillment location'
                        }}
                      </span>
                    </div>
                    <div class="row">
                      <div class="geo-settings-origin">
                        <mat-select
                          #locationSelect
                          [compareWith]="compareWith"
                          formControlName="shippedFromLocation"
                          class="pdq-mat-select pdq-mat-select--default"
                          panelClass="pdq-mat-select--panel"
                          [disableOptionCentering]="true"
                          (selectionChange)="onShippedFromLocationChange($event)">
                          <mat-option [value]="location" *ngFor="let location of shopSettings?.locations"
                            >{{ location.originLocation }}
                          </mat-option>
                        </mat-select>
                      </div>

                      <div style="margin-left: 16px; margin-top: auto">
                        <pdq-checkbox
                          label="Deduct orders from inventory"
                          formControlName="attachLocation"></pdq-checkbox>
                      </div>
                    </div>
                  </ng-container>

                  <!--                    DELIVERY AREA -->
                  <div
                    *ngIf="shippingMethodCategory !== ShippingMethod.STORE_PICK_UP"
                    style="color: #22214c; margin-bottom: 20px; margin-top: 30px">
                    <div
                      *ngIf="
                        shippingMethodCategory !== ShippingMethod.INTERNATIONAL_FIXED &&
                          shippingMethodCategory !== ShippingMethod.INTERNATIONAL_LIVE_RATE &&
                          shippingMethodCategory !== ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE;
                        else internationalDeliveryArea
                      ">
                      <div class="flex-column">
                        <pdq-heading element="h6">Ship to</pdq-heading>
                        <span class="content__general-settings__text">Where this method applies</span>
                      </div>
                      <pdq-radio-group
                        label="Select an option"
                        formControlName="geoDeliveryArea"
                        color="var(--on-surface-default)"
                        (onChange)="onDeliveryAreaChange($event)">
                        <pdq-radio-button
                          *ngFor="
                            let deliveryArea of GEODeliveryAreaConfig
                              | GEODeliveryAreaConfigFilter
                                : shopSettings.selectedLocationCountry
                                : shippingMethodCategory
                          "
                          [checked]="deliveryArea.value === formGroup.get('geoDeliveryArea')?.value"
                          [text]="
                            deliveryArea.displayNameFormatter(
                              deliveryArea.displayName === 'Everywhere'
                                ? geoSettingsOriginCountry
                                : deliveryArea.displayName,
                              shippingMethodCategory
                            )
                          "
                          [value]="deliveryArea.value">
                        </pdq-radio-button>
                      </pdq-radio-group>
                    </div>
                    <ng-template #internationalDeliveryArea>
                      <div class="flex-column gap-16">
                        <pdq-heading element="h6">Geo-settings Destination</pdq-heading>
                        <div class="countries">
                          <country-and-states-dropdown
                            [multiSelect]="true"
                            class="countries"
                            [control]="formGroup?.controls?.international?.controls.countriesAndRegions"
                            [label]="'Enable the delivery area by selecting from the list of locations'">
                          </country-and-states-dropdown>
                        </div>

                        <div>
                          <pdq-radio-group
                            color="var(--on-surface-default)"
                            label="Enable checkout only for selected zip codes (Leave blank input to skip this step)"
                            labelSize="small"
                            (onChange)="handleZipCodesSelect({ operator: $event })">
                            <pdq-radio-button
                              *ngFor="let zipCodeOperator of zipCodesOperatorsConfig"
                              [value]="zipCodeOperator?.value"
                              [checked]="
                                zipCodeOperator.checked(
                                  formGroup?.value?.international?.deliveryAreaZipCodes?.operator ||
                                    zipCodeOperator.defaultValue
                                )
                              "
                              [text]="zipCodeOperator.text">
                            </pdq-radio-button>
                          </pdq-radio-group>
                          <pdq-textarea
                            [control]="
                              formGroup?.controls?.international?.controls.deliveryAreaZipCodes?.controls.zipCodes
                            "
                            invalidMessage="{{ invalidMessage }}"
                            [maxLength]="zipCodesLength"
                            [placeholder]="'Enter enter zip codes separated by commas, for example: 10112, 10023, 10500-10550, U1K 2KK, L1H*, *202*'"></pdq-textarea>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                  <!--                    DELIVERY AREA METHODS WITHOUT MAP -->
                  <div *ngIf="formGroup.get('geoDeliveryArea')?.value === GEODeliveryArea.ZONES" class="row">
                    <div>
                      <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->

                      <input
                        class="pdq-mat-input"
                        matInput
                        type="text"
                        [value]="selectedAddressForZonesTypeControl.value"
                        formControlName="selectedAddressForZonesTypeControl"
                        autocomplete="new-address"
                        matGoogleMapsAutocomplete
                        [country]="shopSettings.selectedLocationCountry"
                        [type]="'region'"
                        [autoCompleteOptions]="googleAutoCompleteOptions"
                        (onAutocompleteSelected)="onZonesOriginAddressSelected($event)" />
                    </div>
                    <pdq-dropdown
                      [options]="zoneOptions"
                      [placeholder]="zonesPlaceholder"
                      [multiSelect]="true"
                      selectBy="value"
                      (onMultiSelectChange)="onZonesChange($event)"></pdq-dropdown>
                  </div>

                  <div *ngIf="formGroup.get('geoDeliveryArea')?.value === GEODeliveryArea.ZIP_CODES">
                    <pdq-radio-group
                      color="var(--on-surface-default)"
                      formControlName="GEODeliveryAreaZipCodesOperator"
                      (onChange)="onZipCodesOperatorChange($event)"
                      label="Zip codes"
                      labelSize="small">
                      <pdq-radio-button
                        *ngFor="let zipCodeOperator of zipCodesOperatorsConfig"
                        [value]="zipCodeOperator.value"
                        [checked]="
                          zipCodeOperator.checked(
                            formGroup.value['GEODeliveryAreaZipCodesOperator'] || zipCodeOperator.defaultValue
                          )
                        "
                        [text]="zipCodeOperator.text">
                      </pdq-radio-button>
                    </pdq-radio-group>
                    <pdq-textarea
                      [control]="formGroup.controls.GEODeliveryAreaZipCodes"
                      invalidMessage="{{ invalidMessage }}"
                      (focusout)="onZipCodeTextareaFocusOut()"
                      [maxLength]="zipCodesLength"
                      placeholder="Enter zip codes separated by commas, for example: 10112, 10023, 10500-10550, U1K 2KK, L1H*, *202*"></pdq-textarea>
                  </div>

                  <!-- EXCLUDE CITIES ON EVERYWHERE SELECTIONS -->
                  <div
                    *ngIf="
                      shippingMethodCategory.includes('domestic') &&
                      (formGroup.get('geoDeliveryArea')?.value === true ||
                        formGroup.get('geoDeliveryArea')?.value === GEODeliveryArea.ZONES)
                    "
                    class="row">
                    <div style="display: flex; flex-direction: column">
                      <div class="content__conditions__input">
                        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                        <input
                          #excludedCitiesListMethodAutocomplete
                          class="pdq-mat-input"
                          matInput
                          style="margin: 0"
                          autocomplete=""
                          type="text"
                          matGoogleMapsAutocomplete
                          [placeholder]="'Exclude cities'"
                          [country]="shopSettings.selectedLocationCountry"
                          [type]="'region'"
                          [formControl]="excludedCitiesControl"
                          [matChipInputFor]="chipListExcluded"
                          [autoCompleteOptions]="googleAutoCompleteOptions"
                          (onAutocompleteSelected)="onExcludedCityAdd($event)" />
                        <mat-chip-grid #chipListExcluded style="margin-top: 10px">
                          <mat-chip-row
                            *ngFor="let excludedCity of excludedCities; let i = index"
                            [selectable]="selectable"
                            [removable]="removable"
                            (removed)="onExcludedCityRemove(excludedCity, i)">
                            {{ excludedCity }}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                          </mat-chip-row>
                        </mat-chip-grid>
                      </div>

                      <div class="content__conditions__input">
                        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                        <input
                          #excludedStatesListMethodAutocomplete
                          class="pdq-mat-input"
                          matInput
                          style="margin: 0"
                          autocomplete=""
                          type="text"
                          matGoogleMapsAutocomplete
                          [placeholder]="'Exclude states'"
                          [country]="shopSettings.selectedLocationCountry"
                          [type]="'region'"
                          [formControl]="excludedStatesControl"
                          (keydown.enter)="onExcludeStateAdd(excludedStatesListMethodAutocomplete.value)"
                          [matChipInputFor]="excludeStates"
                          [autoCompleteOptions]="googleAutoCompleteOptions"
                          (onAutocompleteSelected)="onExcludeStateAdd($event)" />
                        <mat-chip-grid #excludeStates style="margin-top: 10px">
                          <mat-chip-row
                            *ngFor="let excludedState of excludedStates; let i = index"
                            [selectable]="selectable"
                            [removable]="removable"
                            (removed)="onExcludedStateRemove(i)">
                            {{ excludedState }}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                          </mat-chip-row>
                        </mat-chip-grid>
                      </div>
                    </div>
                  </div>

                  <!--                    DELIVERY AREA METHODS WITH MAP -->
                  <div
                    *ngIf="
                      formGroup.get('geoDeliveryArea')?.value == false ||
                      formGroup.get('geoDeliveryArea')?.value == GEODeliveryArea.STATES ||
                      formGroup.get('geoDeliveryArea')?.value == GEODeliveryArea.COUNTY ||
                      formGroup.get('geoDeliveryArea')?.value == GEODeliveryArea.CUSTOM
                    ">
                    <div
                      *ngIf="formGroup.get('geoDeliveryArea')?.value === GEODeliveryArea.COUNTY"
                      class="city-for-local-method">
                      <div class="row">
                        <span class="content__general-settings__text"> Which county are you delivering to?</span>
                      </div>

                      <div class="row">
                        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                        <input
                          class="pdq-mat-input"
                          matInput
                          type="text"
                          formControlName="localCountySelected"
                          autocomplete="new-address"
                          placeholder="Search county"
                          [defaultValue]="localCountySelected?.name"
                          matGoogleMapsAutocomplete
                          [country]="shopSettings.selectedLocationCountry"
                          [types]="['(regions)']"
                          [autoCompleteOptions]="googleAutoCompleteOptions"
                          (onAutocompleteSelected)="onLocalCountySelected($event)" />

                        <div class="content__geography-settings__actions">
                          <button
                            [disabled]="disableApply"
                            class="content__geography-settings__actions-apply"
                            (click)="onCountySearch()">
                            <span
                              *ngIf="isLoadingData; else text"
                              style="margin-left: 25px"
                              class="content__geography-settings__actions-apply-loading">
                              <mat-spinner [diameter]="24" [color]="'#fff'" class=""></mat-spinner>
                            </span>
                            <ng-template #text>Apply</ng-template>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div
                      *ngIf="
                        shippingMethodCategory == ShippingMethod.LOCAL &&
                        formGroup.get('geoDeliveryArea')?.value != GEODeliveryArea.COUNTY &&
                        formGroup.get('geoDeliveryArea')?.value != GEODeliveryArea.CUSTOM
                      "
                      class="city-for-local-method">
                      <div class="row">
                        <span class="content__general-settings__text">Which city's streets are you delivering to?</span>
                      </div>
                      <div class="row">
                        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                        <input
                          class="pdq-mat-input"
                          matInput
                          type="text"
                          formControlName="localCitySelected"
                          autocomplete="new-address"
                          placeholder="Enter delivery city"
                          #localModeCityAutocomplete
                          matGoogleMapsAutocomplete
                          [country]="shopSettings.selectedLocationCountry"
                          [defaultValue]="localMethodCityChoose?.name"
                          [types]="['(regions)']"
                          [autoCompleteOptions]="googleAutoCompleteOptions"
                          (onAutocompleteSelected)="onLocalMethodCityChoose($event)" />
                      </div>
                    </div>

                    <div
                      *ngIf="formGroup.get('geoDeliveryArea')?.value !== 'county'"
                      style="color: #22214c; margin-bottom: 20px">
                      <span class="content__general-settings__text"
                        >Choose a way to create your custom delivery area</span
                      >
                      <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                      <mat-radio-group
                        [(ngModel)]="deliveryAreaMethodRadioGroup"
                        aria-label="Select an option"
                        #geoDeliveryAreaMethod="matRadioGroup"
                        formControlName="geoDeliveryAreaMethod"
                        (change)="onSelectDeliveryAreaMethod($event)">
                        <div
                          class="row geo-padding"
                          *ngIf="
                            getCitiesStatesStreetsText() === 'cities' &&
                            geoSettingsOriginCountryCode === CountryCodes.IL
                          ">
                          <mat-radio-button [value]="GEODeliveryAreaMethod?.LISTED_CITIES">
                            Enable delivery area by entering list of cities (only the ones listed)
                          </mat-radio-button>
                        </div>
                        <div class="row geo-padding" *ngIf="getCitiesStatesStreetsText() === 'states'">
                          <mat-radio-button [value]="GEODeliveryAreaMethod?.LISTED_STATES">
                            Enable delivery area by entering list of states (only the ones listed)
                          </mat-radio-button>
                        </div>
                        <div class="row geo-padding">
                          <mat-radio-button
                            [value]="
                              formGroup.get('geoDeliveryArea')?.value === 'custom'
                                ? GEODeliveryAreaMethod.CUSTOM_PEN_TOOL
                                : getCitiesStatesStreetsText() === 'states'
                                  ? GEODeliveryAreaMethod.STATES_PEN_TOOL
                                  : GEODeliveryAreaMethod.PEN_TOOL
                            ">
                            Draw your delivery area with the pen tool
                          </mat-radio-button>
                        </div>
                        <div
                          class="row geo-padding"
                          *ngIf="formGroup.get('geoDeliveryArea')?.value !== GEODeliveryArea.CUSTOM">
                          <mat-radio-button [value]="getCitiesStatesStreetsText() + '_from_list'">
                            Enter
                            {{ getCitiesStatesStreetsText() }}
                            to create the delivery area's borders
                          </mat-radio-button>
                        </div>
                        <div class="row geo-padding">
                          <mat-radio-button [value]="getCitiesStatesStreetsText() + '_from_address_radius'">
                            Enter an address and distance to create a delivery area
                          </mat-radio-button>
                        </div>
                      </mat-radio-group>
                    </div>
                    <div
                      *ngIf="formGroup.get('geoDeliveryArea')?.value !== 'county'"
                      class="row"
                      style="min-height: 65px">
                      <div class="row" *ngIf="geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod?.LISTED_STATES">
                        <div *ngIf="shippingMethodCategory.includes('domestic')" class="row">
                          <div class="content__conditions__input">
                            <country-and-states-dropdown
                              [control]="listedStatesControl"
                              [multiSelect]="true"
                              [label]="'Enable the delivery area by selecting from the list of states'"
                              [countries]="[shopSettings.selectedLocationCountry]"
                              [error]="!!listedStatesControl.hasError('required')">
                            </country-and-states-dropdown>
                          </div>
                        </div>
                      </div>
                      <div class="row" *ngIf="geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod?.LISTED_CITIES">
                        <div *ngIf="shippingMethodCategory.includes('domestic')" class="row">
                          <div class="content__conditions__input">
                            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                            <input
                              #listedCitiesMethodAutocomplete
                              class="pdq-mat-input"
                              matInput
                              autocomplete=""
                              type="text"
                              matGoogleMapsAutocomplete
                              [placeholder]="'Enter city'"
                              [country]="shopSettings.selectedLocationCountry"
                              [type]="'region'"
                              (keydown.enter)="onListedCity(listedCitiesMethodAutocomplete.value)"
                              [formControl]="listedCitiesControl"
                              [matChipInputFor]="chipListedCities"
                              [autoCompleteOptions]="googleAutoCompleteOptions"
                              (onAutocompleteSelected)="onListedCity($event)" />
                            <mat-chip-grid #chipListedCities style="margin-top: 10px">
                              <mat-chip-row
                                *ngFor="let listedCity of listedCities; let i = index"
                                [selectable]="selectable"
                                [removable]="removable"
                                (removed)="onListedCityRemove(listedCity, i)">
                                {{ listedCity }}
                                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                              </mat-chip-row>
                            </mat-chip-grid>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="
                          geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod.CITIES_FROM_LIST ||
                          geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod.STATES_FROM_LIST ||
                          geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod.STREETS_FROM_LIST
                        ">
                        <div class="row">
                          <div class="content__conditions__input">
                            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                            <input
                              #citiesListMethodAutocomplete
                              class="pdq-mat-input"
                              matInput
                              type="text"
                              matGoogleMapsAutocomplete
                              [placeholder]="'Enter ' + getCitiesStatesStreetsText()"
                              [country]="shopSettings.selectedLocationCountry"
                              [type]="'region'"
                              [formControl]="getCitiesControl"
                              [matChipInputFor]="chipList"
                              [autoCompleteOptions]="googleAutoCompleteOptions"
                              (onAutocompleteSelected)="onCityAdd($event)" />
                            <mat-chip-grid #chipList style="margin-top: 10px">
                              <mat-chip-row
                                *ngFor="let selectedCity of selectedCities; let i = index"
                                [selectable]="selectable"
                                [removable]="removable"
                                (removed)="onCityRemove(selectedCity, i)">
                                {{ selectedCity }}
                                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                              </mat-chip-row>
                            </mat-chip-grid>
                          </div>
                        </div>
                      </div>

                      <div
                        *ngIf="
                          geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod.CITIES_FROM_ADDRESS_RADIUS ||
                          geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod.STATES_FROM_ADDRESS_RADIUS ||
                          geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod.STREETS_FROM_ADDRESS_RADIUS ||
                          geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod.CUSTOM_FROM_ADDRESS_RADIUS
                        ">
                        <div class="row">
                          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                          <input
                            class="pdq-mat-input"
                            matInput
                            type="text"
                            #addressAndRadiusMethodAutocomplete
                            formControlName="polygonAddress"
                            autocomplete="new-address"
                            placeholder="Enter address"
                            matGoogleMapsAutocomplete
                            [country]="shopSettings.selectedLocationCountry"
                            [type]="'region'"
                            [defaultValue]="polygonAddress"
                            [autoCompleteOptions]="googleAutoCompleteOptions"
                            (onLocationSelected)="onSelectAddressAndRadius($event)"
                            [(ngModel)]="polygonAddress" />
                          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                          <input
                            class="pdq-mat-input"
                            matInput
                            autocomplete="off"
                            type="number"
                            formControlName="polygonRadius"
                            placeholder="Min radius"
                            [(ngModel)]="polygonRadius" />
                          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                          <input
                            class="pdq-mat-input"
                            matInput
                            autocomplete="off"
                            type="number"
                            formControlName="maxPolygonRadius"
                            placeholder="Max radius"
                            [(ngModel)]="maxPolygonRadius" />

                          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                          <mat-select
                            #polygonRadiusUnits
                            formControlName="polygonRadiusUnits"
                            panelClass="pdq-mat-select--panel"
                            class="pdq-mat-select pdq-mat-select--default"
                            [value]="polygonRadiusUnits"
                            (selectionChange)="onPolygonRadiusUnitsChange($event)"
                            [disableOptionCentering]="true">
                            <mat-option value="miles">Miles</mat-option>
                            <mat-option value="kilometers">Kilometers</mat-option>
                          </mat-select>
                        </div>
                      </div>
                      <div
                        class="content__geography-settings__actions"
                        *ngIf="
                          geoDeliveryAreaMethod?.value != GEODeliveryAreaMethod.LISTED_STATES &&
                          geoDeliveryAreaMethod?.value != GEODeliveryAreaMethod.LISTED_CITIES
                        ">
                        <button
                          [disabled]="!geoDeliveryAreaMethod?.value"
                          class="content__geography-settings__actions-apply"
                          (click)="onApplyGeo(geoDeliveryAreaMethod?.value, true)">
                          <span
                            *ngIf="isLoadingData; else text"
                            style="margin-left: 25px"
                            class="content__geography-settings__actions-apply-loading">
                            <mat-spinner [diameter]="24" [color]="'#fff'" class=""></mat-spinner>
                          </span>
                          <ng-template #text>Apply</ng-template>
                        </button>
                        <a
                          (click)="fetchCitiesDialog()"
                          class="content__geography-settings__actions-textButton"
                          *ngIf="polygonCities?.length > 0"
                          >List of {{ getCitiesStatesStreetsText() }}</a
                        >
                      </div>
                    </div>

                    <div
                      [ngClass]="
                        geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod?.LISTED_STATES ||
                        geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod?.LISTED_CITIES
                          ? 'display-lefleat-map'
                          : ''
                      ">
                      <app-polygon
                        [editMode]="editMode"
                        [shopSettings]="shopSettings"
                        [selectedOnDrawerMode]="selectedOnDrawerMode"
                        [polygonInputValues]="polygonInputValues"
                        [shippingMethodCategory]="shippingMethodCategory"
                        [selectedCities]="selectedCities"
                        [stage]="geoDeliveryAreaMethod?.value || currentMethodStage"
                        [polygonRadius]="polygonRadius"
                        [maxPolygonRadius]="maxPolygonRadius"
                        [polygonRadiusUnits]="polygonRadiusUnits"
                        [loadedPolygonStage]="loadedPolygonStage"
                        [polygonAddress]="polygonAddress"
                        [polygonLatLngs]="polygonLatLngs"
                        (onSetLocationSettingsValues)="setLocationSettingsValues($event)"
                        (invalidDraw)="onInvalidDraw($event)"
                        (onLoading)="onLoading($event)"
                        (onShowpenToolTip)="onShowPolygonPenToolTip($event)"
                        (onGetCitiesListPressedFromPopUp)="fetchCitiesDialog()"
                        (onDrawerButtonClick)="onDrawerButtonClick($event)"
                        (onCityBoundary)="onLocalCityBoundaryCreates($event)"
                        (onLocalMethodCityChoose)="onUpdateLocalCityName($event)">
                      </app-polygon>

                      <div
                        *ngIf="
                          shippingMethodCategory.includes('domestic') &&
                          formGroup.get('geoDeliveryArea')?.value != GEODeliveryArea.CUSTOM &&
                          formGroup.value.geoDeliveryArea !== 'states'
                        "
                        style="margin-top: 30px"
                        class="row">
                        <span class="content__general-settings__text"
                          >Exclude {{ getCitiesStatesStreetsText() }} from delivery area</span
                        >
                      </div>
                      <div
                        *ngIf="
                          shippingMethodCategory.includes('domestic') &&
                          formGroup.get('geoDeliveryArea')?.value != GEODeliveryArea.CUSTOM
                        "
                        class="row">
                        <div class="content__conditions__input" *ngIf="formGroup.value.geoDeliveryArea !== 'states'">
                          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                          <input
                            #excludedCitiesListMethodAutocomplete
                            class="pdq-mat-input"
                            matInput
                            autocomplete=""
                            type="text"
                            matGoogleMapsAutocomplete
                            [placeholder]="'Enter ' + getCitiesStatesStreetsText() + ' to exclude'"
                            [country]="shopSettings.selectedLocationCountry"
                            [type]="'region'"
                            [formControl]="excludedCitiesControl"
                            [matChipInputFor]="chipListExcluded"
                            [autoCompleteOptions]="googleAutoCompleteOptions"
                            (onAutocompleteSelected)="onExcludedCityAdd($event)" />
                          <mat-chip-grid #chipListExcluded style="margin-top: 10px">
                            <mat-chip-row
                              *ngFor="let excludedCity of excludedCities; let i = index"
                              [selectable]="selectable"
                              [removable]="removable"
                              (removed)="onExcludedCityRemove(excludedCity, i)">
                              {{ excludedCity }}
                              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                            </mat-chip-row>
                          </mat-chip-grid>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--          BLACKOUT DATES-->
            <app-blackout-dates
              *ngIf="
                shippingMethodCategory !== ShippingMethod.FIXED_LIVE_RATE &&
                shippingMethodCategory !== ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE
              "
              [formGroup]="formGroup"
              [showExpansionGuide]="showExpansionGuide"
              [accordionActiveSection]="accordionActiveSection"
              (onCloseExpansionEmit)="onCloseExpansion()"
              (onExpandedNeededEmit)="isExpandedNeeded($event)"
              (onOpenExpansionEmit)="onOpenExpansion($event)">
            </app-blackout-dates>

            <!--          DELIVERY PROMISE-->
            <app-delivery-promise
              *pdqHiddenInGlobaleMode
              [formGroup]="formGroup"
              [shop]="shop"
              [deliveryType]="deliveryType"
              [showExpansionGuide]="showExpansionGuide"
              [accordionActiveSection]="accordionActiveSection"
              (onCloseExpansionEmit)="onCloseExpansion()"
              (onExpandedNeededEmit)="isExpandedNeeded($event)"
              (onOpenExpansionEmit)="onOpenExpansion($event)"
              [shippingMethodCategory]="shippingMethodCategory"
              [googleCalendarIdsList]="googleCalendarIdsList"
              [linkedDatePickerExtensionOptions]="
                linkedDatePickerExtension$ | async | convertDatePickerExtensionsToLinkedOptions
              "
              [multiShipDatePickerProfileOptions]="
                multiShipDatePickerExtension$ | async | convertMultiShipProfilesToLinkedOptions
              "
              [runningABTest]="runningABTest"
              [activeCarrier]="loadValues?.carrier">
            </app-delivery-promise>

            <!--          CONDITIONS SECTION-->
            <app-condition
              [formGroup]="formGroup"
              [accordionActiveSection]="accordionActiveSection"
              [loadedCarrier]="loadedCarrier"
              (onCloseExpansionEmit)="onCloseExpansion()"
              (onExpandedNeededEmit)="isExpandedNeeded($event)"
              (onOpenExpansionEmit)="onOpenExpansion($event)">
            </app-condition>

            <!--              DELIVERY DAYS N TIMES SECTION -->
            <app-days-n-times
              [formGroup]="formGroup"
              [showExpansionGuide]="showExpansionGuide"
              [shopSettings]="shopSettings"
              [accordionActiveSection]="accordionActiveSection"
              (onCloseExpansionEmit)="onCloseExpansion()"
              (onExpandedNeededEmit)="isExpandedNeeded($event)"
              (onOpenExpansionEmit)="onOpenExpansion($event)"></app-days-n-times>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
